import { getJson, postJson, putJson, deleteJson, withDone, withValidate } from '@rad/utility/http';
export const getDirectorTypes = () => getJson('/api/director-types');
export const getDirectors = (type) => getJson('/api/directors', type ? { type } : undefined);
export const getDirector = (id) => getJson(`/api/directors/${id}`);
export const createDirector = (d) => withDone(withValidate(postJson('/api/directors', d)))();
export const updateDirector = (d) => withDone(withValidate(putJson('/api/directors', d)))();
export const deleteDirector = (id) => withDone(deleteJson(`/api/directors/${id}`))();
